/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { UserAnsicht } from '../models';
/**
 * UserAnsichtService - axios parameter creator
 * @export
 */
export const UserAnsichtServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert die useransicht für den Tabellentyp
         * @summary Column Liste
         * @param {number} tabellenTyp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAnsicht: async (tabellenTyp: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tabellenTyp' is not null or undefined
            assertParamExists('getUserAnsicht', 'tabellenTyp', tabellenTyp)
            const localVarPath = `/api/userAnsichten/{tabellenTyp}`
                .replace(`{${"tabellenTyp"}}`, encodeURIComponent(String(tabellenTyp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Speichern Benutzeransicht
         * @summary Column Liste
         * @param {number} tabellenTyp 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserAnsicht: async (tabellenTyp: number, body?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tabellenTyp' is not null or undefined
            assertParamExists('saveUserAnsicht', 'tabellenTyp', tabellenTyp)
            const localVarPath = `/api/userAnsichten/save/{tabellenTyp}`
                .replace(`{${"tabellenTyp"}}`, encodeURIComponent(String(tabellenTyp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAnsichtService - functional programming interface
 * @export
 */
export const UserAnsichtServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAnsichtServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert die useransicht für den Tabellentyp
         * @summary Column Liste
         * @param {number} tabellenTyp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAnsicht(tabellenTyp: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAnsicht>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAnsicht(tabellenTyp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Speichern Benutzeransicht
         * @summary Column Liste
         * @param {number} tabellenTyp 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUserAnsicht(tabellenTyp: number, body?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAnsicht>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUserAnsicht(tabellenTyp, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserAnsichtService - factory interface
 * @export
 */
export const UserAnsichtServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAnsichtServiceFp(configuration)
    return {
        /**
         * Liefert die useransicht für den Tabellentyp
         * @summary Column Liste
         * @param {number} tabellenTyp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAnsicht(tabellenTyp: number, options?: any): AxiosPromise<UserAnsicht> {
            return localVarFp.getUserAnsicht(tabellenTyp, options).then((request) => request(axios, basePath));
        },
        /**
         * Speichern Benutzeransicht
         * @summary Column Liste
         * @param {number} tabellenTyp 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserAnsicht(tabellenTyp: number, body?: string, options?: any): AxiosPromise<UserAnsicht> {
            return localVarFp.saveUserAnsicht(tabellenTyp, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAnsichtService - interface
 * @export
 * @interface UserAnsichtService
 */
export interface UserAnsichtServiceInterface {
    /**
     * Liefert die useransicht für den Tabellentyp
     * @summary Column Liste
     * @param {number} tabellenTyp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAnsichtServiceInterface
     */
    getUserAnsicht(tabellenTyp: number, options?: any): AxiosPromise<UserAnsicht>;

    /**
     * Speichern Benutzeransicht
     * @summary Column Liste
     * @param {number} tabellenTyp 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAnsichtServiceInterface
     */
    saveUserAnsicht(tabellenTyp: number, body?: string, options?: any): AxiosPromise<UserAnsicht>;

}

/**
 * UserAnsichtService - object-oriented interface
 * @export
 * @class UserAnsichtService
 * @extends {BaseAPI}
 */
export class UserAnsichtService extends BaseAPI implements UserAnsichtServiceInterface {
    /**
     * Liefert die useransicht für den Tabellentyp
     * @summary Column Liste
     * @param {number} tabellenTyp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAnsichtService
     */
    public getUserAnsicht(tabellenTyp: number, options?: any) {
        return UserAnsichtServiceFp(this.configuration).getUserAnsicht(tabellenTyp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Speichern Benutzeransicht
     * @summary Column Liste
     * @param {number} tabellenTyp 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAnsichtService
     */
    public saveUserAnsicht(tabellenTyp: number, body?: string, options?: any) {
        return UserAnsichtServiceFp(this.configuration).saveUserAnsicht(tabellenTyp, body, options).then((request) => request(this.axios, this.basePath));
    }
}
